// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import CheckboxPresentationPropsDefault from "@insite/mobius/Checkbox/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@rugby/XDL/types";
import { color } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

const disabledAlpha = 0.5;
export default {
    defaultProps: {
        ...CheckboxPresentationPropsDefault,
        mergeCss: true,
        iconProps: {
            ...CheckboxPresentationPropsDefault?.iconProps,
            size: 22,
            css: css`
                min-width: 22px;
            `,
        },
        css: css`
            label {
                ${wrapInContainerStyles}
            }
            &:hover {
                @media (hover: hover) and (pointer: fine) {
                    span[role="checkbox"][aria-disabled="false"]:not([aria-checked="true"]):not([aria-checked="mixed"]) {
                        color: ${getColor("primary")};
                        background: ${getColor("primary")};
                        border-color: ${getColor("primary")};
                    }
                }
            }
            &:focus {
                outline: none;
                span[role="checkbox"] {
                    outline: none;
                    box-shadow: 0 0 8px ${getColor("primary")};
                }
            }
            span[aria-checked="true"][role="checkbox"]:focus {
                outline: none;
                box-shadow: 0 0 8px 0 ${getColor("primary")};
            }
            span[role="checkbox"] {
                border-width: 2px;
                border-radius: 3px;
                display: flex;
                justify-content: center;
                align-items: center;

                + label {
                    margin-left: 5px;
                }

                &:focus {
                    outline: none;
                    box-shadow: none;
                }

                &[aria-checked="false"]:focus {
                    border-color: ${getColor("primary")};
                }
                &[aria-checked="true"]:focus {
                    outline: none;
                    box-shadow: 0 0 8px 0 ${getColor("primary")};
                }

                &[aria-disabled="true"] {
                    background: ${color("common.disabled", disabledAlpha)};
                    border: 1px solid ${color("common.border", disabledAlpha)};
                    color: ${getColor("common.disabled")};

                    &[aria-checked="true"] {
                        background: ${color("primary", disabledAlpha)};
                        border: 1px solid ${color("primary", disabledAlpha)};
                        color: ${getColor("common.white")};
                    }
                }
            }
        `,
    },
    groupDefaultProps: {},
} as xBaseTheme["checkbox"];
